import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, pxToRem } from '@twisto/styles'

export const block = (theme: Theme) => css`
  display: flex;
  min-height: 38px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  color: currentColor;
  padding: 0 0 0 55px;
  text-decoration: none;
  margin-bottom: 16px;

  span {
    display: block;
  }

  &:hover .text {
    transition-timing-function: ease-out;
    color: ${theme.palette.neutral[900]};
  }

  &:hover .headline {
    transition-timing-function: ease-out;
    color: ${theme.palette.brand[500]};
  }

  &:hover .icon {
    transition-timing-function: ease-out;
    background-color: ${theme.palette.brand[200]};
  }
`

export const headline = (theme: Theme) => css`
  display: block;
  font-size: ${pxToRem(20)};
  font-weight: 500;
  color: ${theme.palette.neutral[900]};
  transition: 0.1s;
  transition: all 0.2s ease-in;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(18)};
  }
`

export const text = (theme: Theme) => css`
  color: ${theme.palette.neutral[700]};
  transition: 0.1s;
  font-size: calc(1rem / 16 * 14);
  line-height: 1.25;
  display: none;
  transition: all 0.2s ease-in;

  ${breakpoint.up('lg')} {
    margin-top: 4px;
    display: block;
  }
`

export const icon = (theme: Theme) => css`
  margin: 0;
  position: absolute;
  left: 0;
  top: 0;
  overflow: visible;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.palette.brand[100]};
  border-radius: 50%;
  transition: all 0.2s ease-in;

  svg {
    fill: ${theme.palette.brand[500]};
  }

  ${breakpoint.up('lg')} {
    margin: 2px 0 0 0;
  }
`
